<header id="main-header">
    <div class="navigation">
        <nav class="global-nav" id="navigation7fc9badd_a881_4d98_9383_c2d16ddc9e44">
            <!-- <div class="nav-header">
           <div class="nav-header-container">
              <div class="brand-container">
                 <a class="brand-link pull-left" href="https://www.nvidia.com/{{locale}}/" title="Artificial Intelligence Computing Leadership from NVIDIA" alt="Artificial Intelligence Computing Leadership from NVIDIA">
                    <svg enable-background="new 0 0 974.7 179.7" version="1.1" viewBox="0 0 974.7 179.7" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" width="110" height="44">
                       <title>
                       </title>
                       <path d="m962.1 144.1v-2.7h1.7c0.9 0 2.2 0.1 2.2 1.2s-0.7 1.5-1.8 1.5h-2.1m0 1.9h1.2l2.7 4.7h2.9l-3-4.9c1.5 0.1 2.7-1 2.8-2.5v-0.4c0-2.6-1.8-3.4-4.8-3.4h-4.3v11.2h2.5v-4.7m12.6-0.9c0-6.6-5.1-10.4-10.8-10.4s-10.8 3.8-10.8 10.4 5.1 10.4 10.8 10.4 10.8-3.8 10.8-10.4m-3.2 0c0.2 4.2-3.1 7.8-7.3 8h-0.3c-4.4 0.2-8.1-3.3-8.3-7.7s3.3-8.1 7.7-8.3 8.1 3.3 8.3 7.7c-0.1 0.1-0.1 0.2-0.1 0.3z"></path>
                       <path d="m578.2 34v118h33.3v-118h-33.3zm-262-0.2v118.1h33.6v-91.7l26.2 0.1c8.6 0 14.6 2.1 18.7 6.5 5.3 5.6 7.4 14.7 7.4 31.2v53.9h32.6v-65.2c0-46.6-29.7-52.9-58.7-52.9h-59.8zm315.7 0.2v118h54c28.8 0 38.2-4.8 48.3-15.5 7.2-7.5 11.8-24.1 11.8-42.2 0-16.6-3.9-31.4-10.8-40.6-12.2-16.5-30-19.7-56.6-19.7h-46.7zm33 25.6h14.3c20.8 0 34.2 9.3 34.2 33.5s-13.4 33.6-34.2 33.6h-14.3v-67.1zm-134.7-25.6l-27.8 93.5-26.6-93.5h-36l38 118h48l38.4-118h-34zm231.4 118h33.3v-118h-33.3v118zm93.4-118l-46.5 117.9h32.8l7.4-20.9h55l7 20.8h35.7l-46.9-117.8h-44.5zm21.6 21.5l20.2 55.2h-41l20.8-55.2z"></path>
                       <path fill="#76B900" d="m101.3 53.6v-16.2c1.6-0.1 3.2-0.2 4.8-0.2 44.4-1.4 73.5 38.2 73.5 38.2s-31.4 43.6-65.1 43.6c-4.5 0-8.9-0.7-13.1-2.1v-49.2c17.3 2.1 20.8 9.7 31.1 27l23.1-19.4s-16.9-22.1-45.3-22.1c-3-0.1-6 0.1-9 0.4m0-53.6v24.2l4.8-0.3c61.7-2.1 102 50.6 102 50.6s-46.2 56.2-94.3 56.2c-4.2 0-8.3-0.4-12.4-1.1v15c3.4 0.4 6.9 0.7 10.3 0.7 44.8 0 77.2-22.9 108.6-49.9 5.2 4.2 26.5 14.3 30.9 18.7-29.8 25-99.3 45.1-138.7 45.1-3.8 0-7.4-0.2-11-0.6v21.1h170.2v-179.7h-170.4zm0 116.9v12.8c-41.4-7.4-52.9-50.5-52.9-50.5s19.9-22 52.9-25.6v14h-0.1c-17.3-2.1-30.9 14.1-30.9 14.1s7.7 27.3 31 35.2m-73.5-39.5s24.5-36.2 73.6-40v-13.2c-54.4 4.4-101.4 50.4-101.4 50.4s26.6 77 101.3 84v-14c-54.8-6.8-73.5-67.2-73.5-67.2z"></path>
                    </svg>
                 </a>
              </div>
              <div class="nav-tools-container">
              </div>
           </div>
        </div>

        <div class="sub-brand-nav">
           <div class="sub-brand-nav-container">
              <div class="brand-nav-left fade mob-wid-55 in" style="width: calc(100% - 108px);">
                 <div id="sub-brand">
                    <a class="sub-brand-name " href="https://www.nvidia.com/{{locale}}/studio/">
                    <span class="sub-brand-label "><b>Studio</b></span>
                    </a>
                 </div>
                 <div class="sub-brand-item" >
                    <a href="https://www.nvidia.com/{{locale}}/studio/software/" class="sub-brand-link">Accelerated Apps</a>
                 </div>
                 <div class="sub-brand-item" >
                    <a href="https://www.nvidia.com/{{locale}}/studio/products/" class="sub-brand-link">Products</a>
                 </div>
                 <div class="sub-brand-item hide" >
                    <span class="sub-brand-link button-dropdown">
                       <div class="more-dropdown">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.4 5">
                             <path d="M12613.6,1800.5a2.654,2.654,0,1,0-2.6,2.5A2.575,2.575,0,0,0,12613.6,1800.5Zm2.7,0a2.708,2.708,0,1,0,2.7-2.5A2.6,2.6,0,0,0,12616.3,1800.5Zm8.1,0a2.654,2.654,0,1,0,2.6-2.5A2.575,2.575,0,0,0,12624.4,1800.5Z" transform="translate(-12608.3 -1798)"></path>
                          </svg>
                       </div>
                    </span>
                    <ul class="dropdown-menu bullet  more-menu">
                       <li class="more-element hide">
                          <a href="https://www.nvidia.com/en-us/studio/software/">Accelerated Apps</a>
                       </li>
                       <li class="more-element hide">
                          <a href="https://www.nvidia.com/en-us/studio/products/">Prodcts</a>
                       </li>
                       <span class="nvArrow" style="left: -30px;"></span>
                    </ul>
                 </div>
              </div>
              <div class="brand-nav-right
                 ">
                 <a class="ic-menu unsubset" id="ic-menu-hamburger" title="Menu">
                    <svg id="menu-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24">
                       <line id="menu-line-top" class="menu-line" x1="1" y1="6" x2="23" y2="6" stroke-width="2.4" vector-effect="non-scaling-stroke" style="transform-origin: 0px 0px 0px; stroke: rgb(255, 255, 255); transform: matrix(1, 0, 0, 1, 0, 0);"></line>
                       <line id="menu-line-mid" class="menu-line" x1="1" y1="12" x2="23" y2="12" stroke-width="2.4" vector-effect="non-scaling-stroke" style="transform-origin: 0px 0px 0px; stroke: rgb(255, 255, 255); transform: matrix(1, 0, 0, 1, 0, 0);"></line>
                       <line id="menu-line-bot" class="menu-line" x1="1" y1="18" x2="23" y2="18" stroke-width="2.4" vector-effect="non-scaling-stroke" style="transform-origin: 0px 0px 0px; stroke: rgb(255, 255, 255); transform: matrix(1, 0, 0, 1, 0, 0);"></line>
                    </svg>
                 </a>

                 <a class="ic-menu unsubset open ic-menu-green hide" id="ic-menu-green" title="Menu">
                     <svg id="menu-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24">
                       <line id="menu-line-top" class="menu-line" x1="1" y1="6" x2="23" y2="6" stroke-width="2.4" vector-effect="non-scaling-stroke" style="backface-visibility: visible; z-index: 0; transform-origin: 0px 0px 0px; stroke: rgb(118, 185, 0); transform: matrix(-0.7071, -0.7071, 0.7071, -0.7071, 16.2426, 24.7279);"></line>
                       <line id="menu-line-mid" class="menu-line" x1="1" y1="12" x2="23" y2="12" stroke-width="2.4" vector-effect="non-scaling-stroke" style="backface-visibility: visible; z-index: 0; transform-origin: 0px 0px 0px; stroke: rgba(118, 185, 0, 0); transform: matrix(-0.7071, -0.7071, 0.7071, -0.7071, 12, 28.9706);"></line>
                       <line id="menu-line-bot" class="menu-line" x1="1" y1="18" x2="23" y2="18" stroke-width="2.4" vector-effect="non-scaling-stroke" style="backface-visibility: visible; z-index: 0; transform-origin: 0px 0px 0px; stroke: rgb(118, 185, 0); transform: matrix(-0.7071, 0.7071, -0.7071, -0.7071, 33.2132, 16.2426);"></line>
                       </svg>
                   </a>
              </div>
           </div>
           <div style="opacity: 0; " class="lightbox-background tablet-only hide"></div>

           <div class="mobile-menu-container background-color-black fade" id="m-menu-list" style="display: none;opacity: 1;overflow: hidden auto;transition: all 0.8s ease 0s;height: 100vh;">
              <div id="screen-bg" class="screen-background" style="display: block; opacity: 1;"></div>
              <ul class="mobile-menu">
                 <li><a href="https://www.nvidia.com/{{locale}}/studio/software/" class="brand-nav-link">Accelerated Apps</a></li>
                 <li><a href="https://www.nvidia.com/{{locale}}/studio/products/" class="brand-nav-link">Products</a></li>
              </ul>
           </div>
        </div>
        <div class="back-to-top" style="display: none;">
           <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47.5 47.5">
              <defs>
                 <style>
                    .cls-1 {
                    fill: #79b600;
                    }
                    .cls-2 {
                    fill: #fff;
                    }
                 </style>
              </defs>
              <title>Back to top</title>
              <rect class="cls-1" width="47.5" height="47.5"></rect>
              <path class="cls-2" d="M13.53,31.77,24,21.29,34.54,31.77l3.23-3.23L24,14.81,10.3,28.54Z" transform="translate(0 -0.5)"></path>
           </svg>
        </div>
        <script>
         jQuery("a#ic-menu-hamburger").on("click",function(){
           jQuery(this).hide();
           jQuery("a#ic-menu-green").removeClass("hide");
           jQuery("#m-menu-list").show();
        });
         jQuery("a#ic-menu-green").on("click",function(){
           jQuery("#m-menu-list").hide();
           jQuery(this).addClass("hide");
           jQuery("a#ic-menu-hamburger").show();
         });
        </script> -->
        </nav>
    </div>
</header>